import { Box, Flex, FormControl, FormHelperText, Text } from "@chakra-ui/react";
import { FieldTemplateProps } from "@rjsf/utils";

import { CustomUiSchemaOptions } from "../../../form-ui-options";
import { FormEnumExplanation, InfoPopover } from "../../form-extras";

export const CustomFieldTemplate = (props: FieldTemplateProps) => {
  const { classNames, help, required, rawErrors, children, schema, uiSchema } = props;
  const isRoot = props.id === "root";
  if (uiSchema?.["isRoot"] || isRoot) return children;

  const hasChildren =
    [...(schema.anyOf ?? []), ...(schema.oneOf ?? [])].filter(
      (property) => typeof property === "object" && property.type !== "null"
    ).length > 1;
  // Ignore anyOf or oneOf because it renders weird errors of values not matching schema's
  // before you have even filled in anything
  const errors = !hasChildren ? [...new Set(rawErrors)] : [];
  const explanation = (uiSchema as CustomUiSchemaOptions | undefined)?.["ui:explanation"];
  const isntFieldOrArray = schema.type !== "object" && schema.type !== "array";

  return (
    <FormControl
      {...(hasChildren
        ? {
            border: "1px solid",
            borderColor: "border",
            p: 4,
            rounded: "base",
          }
        : { w: isntFieldOrArray ? "400px" : undefined })}
      position="relative"
      isRequired={required}
      className={classNames}
    >
      <Flex
        {...(schema.type === "boolean"
          ? { flexDirection: "row-reverse", alignItems: "center", gap: 4 }
          : { flexDirection: "column" })}
        justifyContent="flex-end"
      >
        {/* Weirdly when we call FieldTemplate from the FileWidget the explanation get rendered double
         but outside of this element. So hide it with overflow hidden*/}
        <Flex overflow={isntFieldOrArray ? "hidden" : undefined} w="full" alignItems="flex-end">
          <Box w="full" h="fit">
            {children}
          </Box>
          {!!explanation && <InfoPopover>{explanation}</InfoPopover>}
          <FormEnumExplanation {...props} />
        </Flex>
      </Flex>
      {help && <FormHelperText>{help}</FormHelperText>}
      {/* Cant be FormErrorMessage because that doesn't render, use Set so you remove duplicates */}
      {errors?.map((error, index) => (
        <Text key={index} color="red" textStyle="sm">
          {error}
        </Text>
      ))}
    </FormControl>
  );
};
